import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const baseInfo = {
    grade: {
        queryList: config => createAPI('/baseInfo/gradeInfo/queryList', 'post', config),
        jxxzItem: config => createAPI('/baseInfo/gradeInfo/jxxzItem', 'post', config),
        save: config => createAPI('/baseInfo/gradeInfo/save', 'post', config),
        update: config => createAPI('/baseInfo/gradeInfo/update', 'post', config),
        del: config => createAPI('/baseInfo/gradeInfo/del', 'post', config),
    },

    course: {
        queryList: config => createAPI('/baseInfo/course/queryList', 'post', config),
        initOption: config => createAPI('/baseInfo/course/initOption', 'post', config),
		majorOption: config => createAPI('/baseInfo/course/majorOption', 'post', config),
        deleteById: config => createAPI('/baseInfo/course/deleteById', 'post', config),
        save: config => createAPI('baseInfo/course/save', 'post', config),
        updateAuditState: config => createAPI('baseInfo/course/updateAuditState', 'post', config),
        updateCourseState: config => createAPI('baseInfo/course/updateCourseState', 'post', config),
        queryAuditFlow: config => createAPI('baseInfo/course/queryAuditFlow', 'post', config),
    },

    semester: {
        queryList: config => createAPI('/baseInfo/semester/queryList', 'post', config),
        save: config => createAPI('/baseInfo/semester/save', 'post', config),
        jcsj: config => createAPI('/baseInfo/semester/jcsj', 'post', config),
        xqxl: config => createAPI('/baseInfo/semester/xqxl', 'post', config),
        updateJcsj: config => createAPI('/baseInfo/semester/updateJcsj', 'post', config),
        saveHoliday: config => createAPI('/baseInfo/semester/saveHoliday', 'post', config),
    },

    major: {
        queryList: config => createAPI('/baseInfo/major/queryList', 'post', config),
        initCombo: config => createAPI('/baseInfo/major/initCombo', 'post', config),
        save: config => createAPI('/baseInfo/major/save', 'post', config),
        deleteById: config => createAPI('/baseInfo/major/deleteById', 'post', config),
    },

    class: {
        queryList: config => createAPI('/baseInfo/class/queryList', 'post', config),
        export: config => createAPI('/baseInfo/class/export', 'post', config),
        item: config => createAPI('/baseInfo/class/item', 'post', config),
        stuCombo:  config => createAPI('/baseInfo/class/stuCombo', 'post', config),
        jsItem: config => createAPI('/baseInfo/class/jsItem', 'post', config),
        teacherList: config => createAPI('/baseInfo/class/teacherList', 'post', config),
        studentList: config => createAPI('/baseInfo/class/studentList', 'post', config),
        classOrderNum: config => createAPI('/baseInfo/class/classOrderNum', 'post', config),
        save: config => createAPI('/baseInfo/class/save', 'post', config),
        deleteById: config => createAPI('/baseInfo/class/deleteById', 'post', config),
        upload: config => createAPI('/baseInfo/class/upload', 'post', config),
        loadMajorCombo: config => createAPI('/baseInfo/class/loadMajorCombo', 'post', config),
        batchExport: config => createAPI('/baseInfo/class/batchExport', 'post', config),
    },

    teachingClass: {
        queryList: config => createAPI('/baseInfo/teachingClass/queryList', 'post', config),
        item: config => createAPI('/baseInfo/teachingClass/item', 'post', config),
        classList: config => createAPI('/baseInfo/teachingClass/classList', 'post', config),
        save: config => createAPI('/baseInfo/teachingClass/save', 'post', config),
        deleteById: config => createAPI('/baseInfo/teachingClass/deleteById', 'post', config),
        studentList: config => createAPI('/baseInfo/teachingClass/studentList', 'post', config),
        studentItemList: config => createAPI('/baseInfo/teachingClass/studentItemList', 'post', config),
        addXSMD: config => createAPI('/baseInfo/teachingClass/addXSMD', 'post', config),
        changeXSMD: config => createAPI('/baseInfo/teachingClass/changeXSMD', 'post', config),
        delXSMD: config => createAPI('/baseInfo/teachingClass/delXSMD', 'post', config),
        upload: config => createAPI('/baseInfo/teachingClass/upload', 'post', config),
    },

    classroom: {
        queryList: config => createAPI('/baseInfo/classroom/queryList', 'post', config),
        item: config => createAPI('/baseInfo/classroom/item', 'post', config),
        save: config => createAPI('/baseInfo/classroom/save', 'post', config),
        deleteById: config => createAPI('/baseInfo/classroom/deleteById', 'post', config),
    },

    teachGroup: {
        queryList: config => createAPI('/baseInfo/teachGroup/queryList', 'post', config),
        item: config => createAPI('/baseInfo/teachGroup/item', 'post', config),
        save: config => createAPI('/baseInfo/teachGroup/save', 'post', config),
        deleteById: config => createAPI('/baseInfo/teachGroup/deleteById', 'post', config),
        teacherList: config => createAPI('/baseInfo/teachGroup/teacherList', 'post', config),
        saveJSMD: config => createAPI('/baseInfo/teachGroup/saveJSMD', 'post', config),
        loadAddTea: config => createAPI('/baseInfo/teachGroup/loadAddTea', 'post', config),
        delJSMD: config => createAPI('/baseInfo/teachGroup/delJSMD', 'post', config),
    },

    teacher: {
        queryList: config => createAPI('/baseInfo/teacher/queryList', 'post', config),
        export: config => createAPI('/baseInfo/teacher/export', 'post', config),
        item: config => createAPI('/baseInfo/teacher/item', 'post', config),
        save: config => createAPI('/baseInfo/teacher/save', 'post', config),
        ydxxList: config => createAPI('/baseInfo/teacher/ydxxList', 'post', config),
        saveYdcl: config => createAPI('/baseInfo/teacher/saveYdcl', 'post', config),
        status: config => createAPI('/baseInfo/teacher/status', 'post', config),
        uploadPhoto: config => createAPI('/baseInfo/teacher/uploadPhoto', 'post', config),
        delPhoto: config => createAPI('/baseInfo/teacher/delPhoto', 'post', config),
        upload: config => createAPI('/baseInfo/teacher/upload', 'post', config),
        loadGh: config => createAPI('/baseInfo/teacher/loadGh', 'post', config),
    },

    examCourse: {
        queryList: config => createAPI('/baseInfo/examCourse/queryList', 'post', config),
        item: config => createAPI('/baseInfo/examCourse/item', 'post', config),
        save: config => createAPI('/baseInfo/examCourse/save', 'post', config),
        importWkcj: config => createAPI('/baseInfo/examCourse/importWkcj', 'post', config),
        checkExamStu: config => createAPI('/baseInfo/examCourse/checkExamStu', 'post', config),
        deleteById: config => createAPI('/baseInfo/examCourse/deleteById', 'post', config),
    },
};

export default baseInfo;



// WEBPACK FOOTER //
// ./src/api/modules/baseInfo.js